export default function aos() {
  AOS.init({
    once: true,
    easing: 'ease-in-out',
  })
  // no filtro de produtos por marca
  $('input[type="radio"][name="pet-filter"]').on('change', function() {
    var count = 0
    const maxExecutions = 3
    const intervalId = setInterval(function() {
      AOS.refresh()
      count++
      if (count >= maxExecutions) {
        clearInterval(intervalId)
      }
    }, 1000)
  })
}
